import React, { useEffect, useContext, useState } from "react";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import Cookies from "universal-cookie";
import Barcode from "react-barcode";
import moment from "moment";
import { getVoucherCampaignData } from "../../components/Service";
import { Context } from "../../components/Context";

export default function VoucherCampaign() {
  const { t } = useTranslation();
  const cookies = new Cookies();
  window.document.title = `${t("Panda")}`;

  let lng = "en";
  if (cookies.get("lng") && cookies.get("lng") !== undefined) {
    lng = cookies.get("lng");
  }

  const { value, data_id } = useParams();
  const {
    handleSubmit,
    register,
    setValue,
    setFocus,
    setError,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();
  const [context, setContext] = useContext(Context);
  const [voucherCampaignData, setVoucherCampaignData] = useState({});

  useEffect(() => {
    getVoucherCampaignData(
      `https://s3.me-south-1.amazonaws.com/plus.panda.sa/voucher_campaign/data/${data_id}.json`
    ).then((vc_data) => {
      setVoucherCampaignData(vc_data);
    });
  }, []);

  return (
    <>
      <div className="container">
        <div className="col-sm-12 pt-3">
          <img src="/images/logo.png" alt="logo" width="120" />
          <h4 className="pt-2 px-1 text-green">Here is your voucher</h4>
          <img src={voucherCampaignData.image_link} alt="logo" height="400" />
          <h6 className="pt-2 px-1 mt-2">
            Expiry Date(تاريخ الإنتهاء): {voucherCampaignData.expiry}
          </h6>
          <h6 className="pt-2 px-1" dir="rtl">
            {voucherCampaignData.description_ar}
          </h6>
          <h6 className="pt-2 px-1">{voucherCampaignData.description_en}</h6>
          <h6 className="pt-2 px-1">
            <strong>{voucherCampaignData.terms}</strong>
          </h6>
        </div>

        <div className="row d-flex justify-content-center px-3 pt-4">
          <div className="col-md-6 col-sm-12  mb-3 order-2">
            <div className="dashboard-para my-auto text-center">
              <div className="dashboard-image" id="bar_code_section">
                {
                  <Barcode
                    value={value}
                    fontOptions="bold"
                    background="#e8f3db"
                    lineColor="#004a2c"
                    width={1.7}
                    height={80}
                  />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
